module.exports = __webpack_public_path__ + "static/media/19ESCAP10.a08ffcdb.jpg";